export default __webpack_public_path__ + "static/media/logo-metamask.0aeb9183.png";